<template>
    <body>
        <div v-if="isLoading">
            <spinner></spinner>
        </div>
    
        <div v-else>
            <section>
                <div id="gjs">
                </div>
                <div id="blocks">
                </div>
            </section>
        </div>

        <div v-show="false"> 
          <v-runtime-template :template="template"></v-runtime-template>
        </div>

        <!-- Form select Modal Segment -->
        <div class="wrapper">
            <!-- Modal Component -->
            <b-modal 
            v-model="popUpModals"
            :no-close-on-backdrop="true" 
            hide-header
            hide-header-close
            :hide-footer="modalStatus == 'loading'"
            >
                <b-spinner v-if="modalStatus=='loading'" variant="primary" label="Spinning"></b-spinner>
                <b-card-body v-else>
                <!-- select form list option -->
                <h4>Form builder list</h4>
                <v-style>{{ modalStyle }}</v-style>
                  <label id="formOption" class="d-block">Select Form to be inserted</label>
                  <b-form-select
                    id="selectformOption"
                    label="Form Option"
                    class="form-formOption"
                    :options="this.formTypeListOptions"
                    v-model="selectedForm"
                    @change="loadFormCode($event)"
                    value="Please select"
                  ></b-form-select>

                </b-card-body>

                <!-- Footer -->
                <template v-slot:modal-footer>
                    <b-row style="margin-top: 1em;" >
                    <!-- Change To Success Icon Button -->
                        <b-col sm xs="6"> 
                        <b-button 
                            variant="secondary" outline
                            size="sm" 
                            @click="closeModalForm"
                        >
                        Close
                        </b-button>       
                        </b-col>

                    </b-row>
                </template>
            </b-modal>
        </div>
    
    <CloseConfirmModal 
      v-bind:modalTitle="closeModal.modalTitle"
      v-bind:modalMsg="closeModal.modalMsg"
      v-on:toggle="getCloseAction($event)" 
      ref="closeConfirmModal"
    />

    </body>
</template>

<script>
import Vue from 'vue';
import { apigClient } from '@/shared/api';
import { formBuilder } from "formBuilder";
import { imageHolder } from "../form-builder/img.js";
import { controlLinkHolder } from "../form-builder/hreflink.js";
import { controlMetaHolder } from "../form-builder/meta.js";
// Grapesjs related
import grapesjs from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';
import 'grapesjs-preset-newsletter';
import grapesjsCustomCode from 'grapesjs-custom-code';
// templating and formbuilder
import embeddedForm from '../custom-components/embedded-form'
import VRuntimeTemplate from "v-runtime-template";
import CloseConfirmModal from "./../custom-components/CloseConfirmModal";

const Spinner = () =>
    import ("../shared/Spinner");

export default { 
    name: 'grapesjs',
    props: {
        landingPageBuilderProgressingData: {
        type: Object
        }, 
    },
    components: {
        'embedded-form': embeddedForm,
        Spinner,
        CloseConfirmModal,
        VRuntimeTemplate
    },
    data: function() {
        return {
            savedData: '',
            htmlBuilderData: {},
            name: "Html Builder",
            isLoading: true,
            windowSize: {},
            formListOptions: [],
            formTypeListOptions: [],
            selectedForm: '',
            testComputed: 'computing',
            editor: null,
            htmlForm: '',
            formExist: false,
            template: 
            `<div class="main">
                <v-style>{{ formStyle }}</v-style>
                <div class="form">
                  <div class="form-message">{{ formMessage }}</div>
                  <div v-if="isLoading">
                    <spinner></spinner> 
                  </div>
                  <div class="form-content">
                    <b-form>
                      <div id="fb-template"></div>
                    </b-form>
                  </div>
                </div>
              </div>`,
            // inherited from formBuilder
            formStyle: '',
            modalStyle: '',
            isSubmitted: false,
            isLoading: false,
            formRenderOptions: {
              formData: []
            },
            formMessage: null,
            formAction: null,
            fbBuilder: {},
            formId: null,
            // modal segment
            popUpModals: false,
            isLoading: false,
            isSuccess: false,
            isError: false,
            modalStatus: 'loading',
            title: 'Loading...',
            message: '',
            //For delete modal
            closeModal:{
                modalTitle: 'Close this builder',
                modalMsg: '',
                closeAction: '',
            },
        }
    },
    computed: {
        computeString() {
            return "computed String";
        },
    },
    watch: {
        // editor: function() {
        //     console.log('test watch on editor changes')
        // },
        'window.screen.height': function(){
            console.log(window.screen.height);
        }
    },
    mounted: async function() {
        await this.loadCustomForms();
        this.editor = grapesjs.init({
            html: 'initiate html',
            showOffsets: 1,
            noticeOnUnload: 0,
            fromElement: true,
            container: '#gjs',
            // Size of the editor
            height: `${this.windowSize.height}px`,
            width: `auto`,
            plugins: ['gjs-preset-newsletter', grapesjsCustomCode],
            pluginsOpts: {
                'gjs-preset-newsletter': {},
                grapesjsCustomCode: {
                    blockLabel:'Custom Code'
                }
            },
            // Disable the storage manager for the moment
            storageManager: false,
            blockManager: {
                appendTo: '#blocks',
                blocks: []
            },
            modal: {
                // options
            }
        });
        // ### Pre-construct data
        if(this.landingPageBuilderProgressingData){
        this.savedData = this.landingPageBuilderProgressingData;
        this.savedDataProcessing(this.landingPageBuilderProgressingData);
        }
        // blockManager/panel/modal customization
        let that = this;
        const blockManager = this.editor.BlockManager;
        const panel = this.editor.Panels;
        const modal = this.editor.Modal;
        panel.addButton('options', [{ id: 'reset', className: 'fa fa-recycle', command: function() { that.resetHtmlBuilder(); }, attributes: { title: 'Reset' } }, ]);
        panel.addButton('options', [{ id: 'undo', className: 'fa fa-undo', command: 'undo', attributes: { title: 'Undo' } }, ]);
        panel.addButton('options', [{ id: 'redo', className: 'fa fa-repeat', command: 'redo', attributes: { title: 'Redo' } }, ]);
        panel.addButton('options', [{ id: 'preview', className: 'fa fa-eye', command: 'preview', attributes: { title: 'Preview' } }, ]);
        panel.addButton('options', [{ id: 'save', className: 'fa fa-floppy-o', command: function() { that.saveHtmlBuilder(); }, attributes: { title: 'Save Template' } }, ]);
        panel.addButton('options', [{ id: 'close', className: 'fa fa-window-close', command: function() { that.closeHtmlBuilder(); }, attributes: { title: 'Close Builder' } }, ]);
        // panel.addButton('options', [ { id: 'trash', className: 'fa fa-trash', command: 'clear', attributes: { title: 'trash' } }, ]);
        // Add blocks
        blockManager.add('my-map-block', {
            label: 'Simple map block',
            attributes: {
                class: 'fa fa-map-o'
            },
            content: {
                // Built-in 'map' component
                type: 'map',
                style: { height: '350px' },
                // Once inserted it can't be removed (just an example)
                removable: false
            }
        });
        blockManager.add('add-form', {
            label: 'Add form selector',
            attributes: {
                class: 'fa fa-list-alt',
                name: 'formSelector'
            },
            content: `<div data-gjs-custom-name="formSelector">
              </div>`
        });
        
        blockManager.add('nod-template', {
            label: 'nod-template',
            attributes: {
                class: 'fa fa-list-alt',
                name: 'nod-template'
            },
            content: `<div data-gjs-custom-name="nod-template">
              </div>`
        });

        // add event to open modal when (Block get :drag ->:stop)
        this.editor.on('block:drag:stop', model => {
            try {
              if (model.getName() === 'formSelector') {
                if(this.formExist){
                alert('Only single form can exist in one landing-page');
                }else{
                this.openModalForm();
                }
              }
              // Test inject formBuilder to grapesjs here
              if (model.getName() === 'vTemplate') {
                model.set({ selectable: false, editable: false, removable: false, draggable: false, 
                                      propagate: ["selectable", "editable", "removable", "draggable"],})
                this.$forceUpdate();
              }
              // inject NOD-template into editor
              if (model.getName() === 'nod-template') {
                let nodTemplate = {"editorHtml":"<table id=\"ipc9f\"><tbody id=\"iuxm6\"><tr id=\"ihd33\"><td id=\"ian8v\"></td></tr></tbody></table><div id=\"ihw9y\"></div><footer id=\"i850l\"><div class=\"footer-copyright\"><div class=\"column1 -Nature-One-Dairy-Pty-Ltd-2020\"><h3>© Nature One Dairy Pty Ltd 2020\n      </h3></div><div class=\"column1 Powered-by\"><h3>Powered by\n        <img align=\"middle\" src=\"https://resources.dev.ypbconnect.com/companies/ypb-group/media/2020-03-16/ypb-logo_1584335174485.png\" class=\"YPB-new-logo\"/></h3></div></div><div align=\"right\" class=\"footer-link\"><div align=\"right\" class=\"column2 TERMS-OF-USE\"><h3>TERMS OF USE\n      </h3></div><div align=\"right\" class=\"column2 PRIVACY-POLICY\"><h3>PRIVACY POLICY\n      </h3></div></div></footer>","formStyle":"* { box-sizing: border-box; } body {margin: 0;}#ipc9f{height:15vh;margin:3vh auto 10px auto;padding:5px 5px 5px 5px;width:100%;}#ian8v{padding:0;margin:0 0 0 0;vertical-align:top;background-image:url(https://resources.dev.ypbconnect.com/companies/ypb-group/media/2020-03-16/nod-logo_1584349464791.png);background-attachment:scroll;background-position:center center;background-size:contain;background-repeat:no-repeat;border-radius:0 0 0;}footer{font-family:Roboto;height:14vh;background-color:rgb(241, 243, 246);display:flex;position:relative;bottom:0px;width:100%;margin-top:20vh;}.footer h3{font-size:0.58rem !important;}.footer-copyright{width:60%;}.footer-link{margin-top:2vh;width:30%;}.column1{width:100%;margin-top:1em;margin-right:2em;margin-bottom:1em;margin-left:2em;}.column1 h3{font-weight:600;}.TERMS-OF-USE{font-size:8px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.38;letter-spacing:normal;color:rgb(150, 150, 150);}.PRIVACY-POLICY{font-size:8px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.38;letter-spacing:normal;color:rgb(150, 150, 150);}.-Nature-One-Dairy-Pty-Ltd-2020{font-size:8px;font-weight:bold;font-stretch:normal;font-style:normal;line-height:1.38;letter-spacing:normal;color:rgb(150, 150, 150);}.Powered-by{font-size:10px;font-weight:500;font-stretch:normal;font-style:normal;line-height:1.4;letter-spacing:normal;color:rgb(152, 152, 152);}.YPB-new-logo{width:13vw;height:7vh;object-fit:contain;}"}
                this.savedDataProcessing(nodTemplate);  
              }
            } catch (error) {
                // console.log(error)
            }
        });
        // add event on delete to update formExist status
        this.editor.on('component:remove', comp => {
            if(comp.toHTML().includes(`<div startForm="#`)){
                this.selectedForm = '';
                this.formExist = false;
            }
        });
    },
    created() {
        this.windowSize.height = window.innerHeight;
        this.windowSize.width = window.innerHeight;
        window.addEventListener("resize", this.windowSizeHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.windowSizeHandler);
    },
    methods: {
        editorComponents(){
            let editorHtml = this.editor.getHtml();
            let editorCss = this.editor.getCss();
            let editorDom = this.editor.DomComponents;
            // console.log for check these raw data
        },
        saveHtmlBuilder() {
        // save Buillder state
        let editorHtml = this.editor.getHtml();
        let editorCss = this.editor.getCss();
        this.htmlBuilderData.editorHtml = editorHtml;
        this.htmlBuilderData.formStyle = editorCss;
        this.$emit('toggle', {showBuilder:false, htmlBuilderData: this.htmlBuilderData});
        },
        closeHtmlBuilder() {
        //prompt pop-up for close confirmation
        let editorHtml = this.editor.getHtml();
            if(editorHtml != this.savedData.editorHtml){
            this.$refs.closeConfirmModal.openModal();
            }else{
            this.closeOnly()
            }
        },
        closeBuilder() {
            if(this.closeModal.closeAction=='CLOSE-ONLY'){
            this.closeOnly()
            }else{
            this.saveHtmlBuilder();
            }
        },
        closeOnly() {
            this.$emit('toggle', {htmlBuilderData: this.savedData});
        },
        getCloseAction(data){
        let that = this;
            if(data && data.closeAction){
                that.closeModal.closeAction=data.closeAction;
                that.closeBuilder();
            }
        },
        resetHtmlBuilder() {
        // reset
        this.editor.setComponents();
        this.editor.setStyle();
        },
        windowSizeHandler(e) {
            this.windowSize.height = e.target.innerHeight; 
            this.windowSize.width = e.target.innerWidth; 
        },
        async formBuilderLoad(formCode){
        // getting formBuilder
        let responseObjects = await this.getFormData(formCode);
        vm.$forceUpdate();
        this.formRenderOptions = {
            formData: responseObjects
        }
        this.fbBuilder = $('#fb-template').formRender(this.formRenderOptions);
        this.htmlForm = $('#fb-template').formRender('html'); // HTML string
        vm.$forceUpdate();
        
        //initiate GrapesJS editor component
        },
        async savedDataProcessing(landingPageData){  
          let htmlLP = landingPageData.editorHtml;
          let cssLp = landingPageData.formStyle;
          if(htmlLP.lastIndexOf(`<div startForm="#`)>0){
            let landingPageFormCode = htmlLP.substring(htmlLP.lastIndexOf(`<div startForm="#`)+17,htmlLP.lastIndexOf(`<div startForm="#`)+17+5);
            if(landingPageFormCode){
            this.formExist = true;
            let upperLandingPage = htmlLP.substring(0, htmlLP.lastIndexOf(`<div startForm="#`+landingPageFormCode+`"/>`));
            let lowerLandingPage = htmlLP.substring(htmlLP.lastIndexOf(`<div endForm="#`+landingPageFormCode+`"/>`));
            // do get from embeddedFormCode and render it between the rawHtml, embeddedForm in middle then append the html above and below it
            this.editor.addComponents({content:upperLandingPage});
            await this.loadFormCode(landingPageFormCode);
            this.editor.addComponents({content:lowerLandingPage});
            }
          }else{
          this.editor.setComponents(landingPageData.editorHtml);
          }
          this.editor.setStyle(cssLp);
          return; 
        },
        async loadFormCode(formCode){
            this.modalStatus = 'loading';
            await this.formBuilderLoad(formCode);
            this.editor.addComponents({
                    content:
            `
            <div data-gjs-custom-name="vTemplate" data-gjs-removable="true">
                <div data-gjs-droppable="false" data-gjs-copyable="false" data-gjs-editable="false" data-gjs-removable="false" data-gjs-draggable="false" data-gjs-propagate='["droppable", "editable", "draggable", "removable", "copyable"]'> 
                <div startForm="#${formCode}"/><div formId"ID-${this.formId}"/>
                <style>${this.formStyle}</style>
                <div class="form-content"><form class=""><div>
                ${this.htmlForm} 
                </div></form></div>
                <div endForm="#${formCode}"/>
                </div>
            </div>
            `,
            droppable: false, removable: true, 
                    });
            this.closeModalForm();
            this.modalStatus = 'loaded';
            this.formExist = true;
        },
        loadCustomForms: async function() {
        let method = "GET";
        let pathTemplate = "/formBuilder";
        var additionalParams = {
            queryParams: {
            params: JSON.stringify({
                table: "form_builder",
                fields: ["id, formName, formCode, formType, updatedAt, createdAt, updatedBy, createdBy"],
                
            })
            }	        
        }
            let pathParams = {};
            let that = this;
            apigClient
                .invokeApi(pathParams, pathTemplate, method, additionalParams)
                .then(function(result) {
                let response = result.data;
                if (response.status) {
                    let formListData = response.data;
                    for(let f=0; f < formListData.length; f++){
                    that.formTypeListOptions.push({"value": formListData[f].formCode, "text": `${formListData[f].formName}, [${formListData[f].formType}]`})
                    }
                } else {
                    console.log('get bad status from load Forms' + response.status);
                }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getFormData(formCode) {
            var method = 'GET';
            var pathTemplate = '/formBuilder/byCode/' + formCode;
            var additionalParams = {};
            var pathParams = {};
            // this.isLoading = true;
            var that = this;
            return apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
                .then(function(result) {
                    let response = result.data;
                    that.isLoading = false;
                    if (response.status) {
                        document.title = response.data.formName;
                        that.formMessage = response.data.formMessage;
                        that.formId = response.data.id;
                        that.formAction = response.data.formAction;
                        that.formStyle = response.data.formStyle;
                        console.log(that.formStyle)
                        return response.data.formContent;
                    } else {
                        return response.message;
                    }
                }).catch(function(error) {
                    that.isLoading = false;
                    return error.message;
                });
        },
        // Modal Control
        closeModalForm(){
        this.popUpModals = false;
        },
        openModalForm() {
        this.modalStatus = 'loaded';
        this.popUpModals = true;
        }
    }
}
</script>
<style scoped>
/* body,
html {
    height: 100% !important;
    margin: 0 !important;
} */

/* Let's highlight canvas boundaries */

#gjs {
    border: 3px solid #444 !important;
}

/* Reset some default styling */

/* .gjs-cv-canvas {
    top: 0 !important;
    width: 100% !important;
    height: 100% !important;
} */
</style>
